import { NgModule } from 'ng-metadata/core';

ngSlickConfig.$inject = ['slickCarouselConfig'];
export function ngSlickConfig(slickCarouselConfig) {
  slickCarouselConfig.dots = true;
  slickCarouselConfig.autoplay = true;
  slickCarouselConfig.methods = {};
}



// WEBPACK FOOTER //
// ./resources/assets/js/config/slick.config.ts